import React, {useState, useEffect} from 'react';
import {View, Text, Image, StyleSheet, Dimensions} from 'react-native';
import AsyncStorage from '@react-native-async-storage/async-storage';
import topImage from '../../assets/judgeCourtBanner.png';
import Svg, {Defs, LinearGradient, Stop, Rect} from 'react-native-svg';

const TopBar = ({children}) => {
  const [name, setName] = useState('');
  const [user_id, setUser_id] = useState('');
  const [mobile_no, setMobile_no] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadUserData = async () => {
      try {
        const nameValue = await AsyncStorage.getItem('name');
        const userIdValue = await AsyncStorage.getItem('user_id');
        const mobileValue = await AsyncStorage.getItem('mobile_no');

        // JSON.parse শুধু তখনই করবেন যদি আগে JSON.stringify করে সেভ করে থাকেন
        setName(nameValue ? JSON.parse(nameValue) : '');
        setUser_id(userIdValue ? JSON.parse(userIdValue) : '');
        setMobile_no(mobileValue ? JSON.parse(mobileValue) : '');
      } catch (error) {
        console.error('Error loading user data:', error);
      } finally {
        setLoading(false);
      }
    };

    loadUserData();
  }, []);

  if (loading) {
    return (
      <View style={styles.topBar}>
        <Text style={styles.loadingText}>Loading...</Text>
      </View>
    );
  }

  return (
    <View style={styles.topBar}>
      {/* ===== নাম + Super Admin ===== */}
      <View style={styles.nameWrapper}>
        {/* SVG ব্যাকগ্রাউন্ড + খারা দাগ */}
        <Svg height="100%" width="100%" style={StyleSheet.absoluteFill}>
          <Defs>
            <LinearGradient id="fadeGrad" x1="0" y1="0" x2="1" y2="0">
              <Stop offset="0" stopColor="#FFFFFF" stopOpacity="0.25" />
              <Stop offset="0.6" stopColor="#FFFFFF" stopOpacity="0.10" />
              <Stop offset="1" stopColor="#FFFFFF" stopOpacity="0" />
            </LinearGradient>
          </Defs>

          {/* হালকা ফেইড ব্যাকগ্রাউন্ড */}
          <Rect
            x="0"
            y="0"
            width="100%"
            height="100%"
            fill="url(#fadeGrad)"
            rx="12"
            ry="12"
          />

          {/* বামের সোনালি খারা দাগ */}
          <Rect
            x="0"
            y="0"
            width="3.5"
            height="100%"
            fill="#FFD700"
            rx="2"
            ry="2"
          />
        </Svg>

        {/* টেক্সট কন্টেন্ট */}
        <View style={styles.textContent}>
          {user_id == '100' && (
            <View>
              <Text style={styles.nameText}>SUPER ADMIN</Text>
            </View>
          )}
          <Text style={styles.nameText} numberOfLines={1}>
            {name || 'No Name'}
          </Text>
        </View>
      </View>

      {/* ===== মাঝের ব্যানার ===== */}
      <View style={styles.centerContent}>
        <Image style={styles.bannerImage} source={topImage} />
        <Text style={styles.textS}>(For Judge Court Diary & Case Search)</Text>
        <Text style={styles.textSP}>Powered By: Siddique Enterprise</Text>
      </View>

      {/* ===== ডানপাশের ১ ===== */}
      <View style={styles.trialWrapper}>
        <View>
          <View>
            <Text style={styles.trialText}>( TRIAL )</Text>
          </View>
        </View>
      </View>
      <Text style={styles.rightText}>1</Text>
    </View>
  );
};

const styles = StyleSheet.create({
  topBar: {
    width: '100%',
    height: 73,
    backgroundColor: '#0373BB',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative', // absolute চাইল্ডদের জন্য দরকার
  },

  // বাম পাশের নাম (layout-এ প্রভাব ফেলে না)
  nameText: {
    position: 'absolute',
    left: 12,
    top: 8,
    color: '#fff',
    fontSize: 14,
    fontWeight: 'bold',
    zIndex: 10,
  },

  trialText: {
    position: 'absolute',
    top: 8,
    width: 100,
    color: '#fff',
    fontSize: 24,
    fontWeight: 'bold',
    zIndex: 10,
  },

  // মাঝের অংশ
  centerContent: {
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: 200,
  },
  bannerImage: {
    width: 225,
    height: 27,
    marginTop: 3,
  },
  textS: {
    fontSize: 15,
    color: '#ff0',
    fontFamily: 'Aachen-BT',
    lineHeight: 19,
    textAlign: 'center',
  },
  textSP: {
    fontSize: 20,
    color: '#ff0',
    fontFamily: 'Aachen-BT',
    lineHeight: 20,
    textAlign: 'center',
  },

  // ডান পাশের ১
  rightText: {
    position: 'absolute',
    right: 12,
    top: 8,
    color: '#fff',
    fontSize: 12,
    fontWeight: 'bold',
  },

  loadingText: {
    color: '#fff',
    fontSize: 14,
  },
  nameWrapper: {
    position: 'absolute',
    left: 20,
    top: 11,
    zIndex: 10,
    maxWidth: 275,
    minHeight: 52,
    justifyContent: 'center',
  },

  trialWrapper: {
    position: 'absolute',
    left: 1100,
    top: 0,
    zIndex: 10,
    maxWidth: 275,
    minHeight: 26,
    justifyContent: 'center',
  },

  textContent: {
    paddingLeft: 14,
    paddingRight: 16,
    paddingVertical: 2,
  },

  adminBadge: {
    backgroundColor: 'rgba(252, 249, 51, 0.4)',
    paddingHorizontal: 6,
    paddingVertical: 2,
    marginBottom: 3,
    alignSelf: 'flex-start',
  },

  adminBadgeText: {
    color: '#000',
    fontSize: 9,
    fontWeight: 'bold',
    letterSpacing: 0.4,
  },

  nameText: {
    color: '#FFFFFF',
    fontSize: 14,
    fontWeight: '600',
    textShadowColor: 'rgba(0, 0, 0, 0.4)',
    textShadowOffset: {width: 0, height: 1},
    textShadowRadius: 2,
  },
});

export default TopBar;
